import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { ActivatedRoute, Router } from '@angular/router'
import { BeatsSortBy, EmailSourceType } from '../../../enums/enums'
import { ILicense, ILicenseBulkDiscount } from '../../../Interface/license'
import { AuthService } from '../../../services/auth.service'
import { LicenseService } from '../../../services/license.service'
import { LicensesBulkDiscountService } from '../../../services/licenses-bulk-discount.service'
import { I18nService, LgType } from '../../../services/prod/i18n.service'
import { ProducerService } from '../../../services/producer.service'
import { SsrService } from '../../../services/ssr.service'
import { AppType } from '../../../types/app.type'
import { GetBeatmakerContactsResponse, ProducerType } from '../../../types/producer.type'

@Component({
  selector: 'bmcore-beatmaker-page',
  templateUrl: './bmcore-beatmaker-page.component.html',
  styleUrls: ['./bmcore-beatmaker-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreBeatmakerPageComponent implements OnInit {
  constructor(
    private activatedRoute: ActivatedRoute,
    private producerService: ProducerService,
    private licenseService: LicenseService,
    private licensesBulkDiscountService: LicensesBulkDiscountService,
    private titleService: Title,
    private authService: AuthService,
    private router: Router,
    private ssrService: SsrService,
    private i18nService: I18nService
  ) {}

  @Input() appType: AppType

  @Input() showVerificationIcon = false

  beatmakerIdOrUrl: number | string
  beatmakerId: number
  userID: number
  producer: ProducerType
  licenses: ILicense[] = []
  licenseBulkDiscounts: ILicenseBulkDiscount[] = []
  sourceType = EmailSourceType.BeatmakersTV // Need to determine where the letter came from (bmcore-contacts-form)

  BMTVContacts: GetBeatmakerContactsResponse

  lg: LgType

  protected readonly BeatsSortBy = BeatsSortBy

  ngOnInit(): void {
    this.lg = this.i18nService.getLanguageForPage()

    this.beatmakerIdOrUrl = this.activatedRoute.snapshot.paramMap.get('beatmakerIdOrURL')

    this.authService.user.subscribe(res => {
      this.userID = res.id
    })

    this.producerService.producer.subscribe(res => {
      this.producer = res
    })

    this.ssrService.wait('bmstv-beatmaker-page: producerService.getInformation')
    this.producerService.getInformation(this.beatmakerIdOrUrl).subscribe(
      (res: ProducerType) => {
        this.ssrService.ready('bmstv-beatmaker-page: producerService.getInformation')
        this.producer = res
        this.setTitle(this.producer.beatmakerName)

        this.beatmakerId = res.beatmakerId

        this.ssrService.wait('bmstv-beatmaker-page: licenseService.licensesSubject')
        this.licenseService.getLicenses(this.beatmakerId)

        this.ssrService.wait('bmstv-beatmaker-page: licensesBulkDiscountService.licenseDiscountSubject')
        this.licensesBulkDiscountService.getLicensesDiscount(this.beatmakerId)

        this.subscribeLicenses()
        this.subscribeLicenseDiscounts()

        // TODO (sv): возможно лучше перенести запрос как можно ближе к компоненте
        this.producerService.getBeatmakerContacts(this.beatmakerId).subscribe(contacts => {
          this.BMTVContacts = contacts
        })
      },
      () => {
        this.router.navigate(['/404'])
      }
    )
  }

  subscribeLicenses() {
    this.licenseService.licensesSubject.subscribe(res => {
      this.ssrService.ready('bmstv-beatmaker-page: licenseService.licensesSubject')
      this.licenses = res
    })
  }

  subscribeLicenseDiscounts() {
    this.licensesBulkDiscountService.licenseDiscountSubject.subscribe(res => {
      this.ssrService.ready('bmstv-beatmaker-page: licensesBulkDiscountService.licenseDiscountSubject')
      this.licenseBulkDiscounts = res
    })
  }

  setTitle(beatmakerName: string) {
    this.titleService.setTitle(this.lg.documentTitles.setBeatmakerPageTitle(beatmakerName))
  }
}
